import { Component } from '@angular/core';
import { ContainerMarginComponent } from '@app/modules/shared/components/container-margin/container-margin.component';

@Component({
  selector: 'app-closure',
  standalone: true,
  imports: [ContainerMarginComponent],
  templateUrl: './closure.component.html',
  styleUrl: './closure.component.scss'
})
export class ClosureComponent {}
